(function () {
  // Robust parser: handles ISO, "YYYY/MM/DD HH:MM(+TZ)", "YYYY-MM-DD HH:MM:SS", and weird 24:00 -> next day
  function parseDateToMs(input) {
    if (!input) return NaN;
    input = input.trim();

    // Normalize common separators to a consistent shape
    // Replace multiple slashes (e.g. 2025/11/02/24:00+0100) -> "2025/11/02 24:00+0100"
    input = input.replace(/\/(?=\d{2}:)/, ' ').replace(/\//g, '-');

    // If time part has 24:00 -> convert to 00:00 of next day
    let m24 = input.match(/(\d{4})-(\d{2})-(\d{2}).*?24:(\d{2})(?::(\d{2}))?/);
    if (m24) {
      const year = parseInt(m24[1], 10);
      const month = parseInt(m24[2], 10) - 1;
      const day = parseInt(m24[3], 10);
      // Move to next day
      const dt = new Date(year, month, day, 0, parseInt(m24[4] || '0', 10), parseInt(m24[5] || '0', 10));
      dt.setDate(dt.getDate() + 1);
      return dt.getTime();
    }

    // Try direct Date.parse (accepts ISO)
    let parsed = Date.parse(input);
    if (!isNaN(parsed)) return parsed;

    // Try replace space between date/time with 'T' and add Z if no timezone
    const isoLike = input.replace(' ', 'T');
    parsed = Date.parse(isoLike);
    if (!isNaN(parsed)) return parsed;

    // Try adding 'Z' if it looks like no timezone present
    if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2})?$/.test(isoLike)) {
      parsed = Date.parse(isoLike + 'Z');
      if (!isNaN(parsed)) return parsed;
    }

    // Fallback: manual parse for YYYY-MM-DD[ T]HH:MM(:SS)? optionally with +/-HHMM timezone
    const m = input.match(/^(\d{4})[-\/](\d{2})[-\/](\d{2})(?:[ T](\d{2}):(\d{2})(?::(\d{2}))?)?(?:([+-]\d{2}:?\d{2}|Z))?$/);
    if (m) {
      const year = parseInt(m[1], 10);
      const month = parseInt(m[2], 10) - 1;
      const day = parseInt(m[3], 10);
      const hour = parseInt(m[4] || '0', 10);
      const minute = parseInt(m[5] || '0', 10);
      const second = parseInt(m[6] || '0', 10);
      // Ignore timezone offset for manual local creation (best-effort)
      return new Date(year, month, day, hour, minute, second).getTime();
    }

    return NaN;
  }

  function pad(n) { return String(n).padStart(2, '0'); }

  function initCountdown(wrapper) {
    if (!wrapper) return;
    // avoid double-init
    if (wrapper.dataset.countdownInit) return;
    wrapper.dataset.countdownInit = "1";

    const raw = wrapper.getAttribute('data-datetime') || '';
    const endTime = parseDateToMs(raw);

    console.log('initCountdown — raw data-datetime:', raw, 'parsed ms:', endTime);

    if (isNaN(endTime)) {
      console.error('Countdown: could not parse date ->', raw);
      // Hide wrapper or display nothing to avoid showing NaN
      wrapper.style.opacity = '1';
      return;
    }

    const elDays = wrapper.querySelector('.days');
    const elHours = wrapper.querySelector('.hours');
    const elMinutes = wrapper.querySelector('.minutes');
    const elSeconds = wrapper.querySelector('.seconds');

    // If elements missing, add safe nodes
    if (!elDays && !elHours && !elMinutes && !elSeconds) {
      wrapper.innerHTML = '<div class="days">00:</div><div class="hours">00:</div><div class="minutes">00:</div><div class="seconds">00</div>';
    }

    function tick() {
      const now = Date.now();
      let diff = endTime - now;

      if (diff <= 0) {
        clearInterval(wrapper._countdownInterval);
        if (wrapper.querySelector('.days')) wrapper.querySelector('.days').style.display = 'inline-block';
        if (wrapper.querySelector('.days')) wrapper.querySelector('.days').textContent = '00:';
        if (wrapper.querySelector('.hours')) wrapper.querySelector('.hours').textContent = '00:';
        if (wrapper.querySelector('.minutes')) wrapper.querySelector('.minutes').textContent = '00:';
        if (wrapper.querySelector('.seconds')) wrapper.querySelector('.seconds').textContent = '00';
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      const dEl = wrapper.querySelector('.days');
      if (dEl) {
        if (days > 0) { dEl.style.display = 'inline-block'; dEl.textContent = pad(days) + ':'; }
        else { dEl.style.display = 'none'; }
      }
      const hEl = wrapper.querySelector('.hours'); if (hEl) hEl.textContent = pad(hours) + ':';
      const mEl = wrapper.querySelector('.minutes'); if (mEl) mEl.textContent = pad(minutes) + ':';
      const sEl = wrapper.querySelector('.seconds'); if (sEl) sEl.textContent = pad(seconds);
    }

    // run immediately then every second
    tick();
    wrapper._countdownInterval = setInterval(tick, 1000);
  }

  function loadCountdowns() {
    document.querySelectorAll('.countdown_timer_wrapper').forEach((wrapper) => initCountdown(wrapper));
  }

  // Normal page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadCountdowns);
  } else {
    loadCountdowns();
  }

  // Shopify editor events
  document.addEventListener('shopify:section:load', loadCountdowns);
  document.addEventListener('shopify:section:select', loadCountdowns);
  document.addEventListener('shopify:block:select', loadCountdowns);
})();